<template>
  <nav
    id="n-categories"
    v-if="categories.length"
    class="n-categories container">
    <div class="n-categories__inner">
      <ul class="n-categories__list">
        <li
          v-for="(category, i) in computedCategories"
          :key="category.id"
          class="n-categories__entry"
          :class="{
            '-is-active': currentCategoryId == category.id,
            '-is-disabled': i >= nVisible
          }"
          :data-slug="category.slug"
          :data-id="category.id">
          <button
            class="n-categories__cta"
            @click="goTo(category.id)"
            >{{ category.name }}</button>
        </li>
      </ul>
      <div
        class="n-categories__more"
        :class="{'-is-disabled': !hasMore}"
        :hidden="!hasMore">
        <actions-button
          icon="icon-caret-bottom"
          position="post"
          size="s"
          theme="ghost"
          ref="morebutton"
        >{{ $t('sayl-oat.more_button') }}</actions-button>
        <!-- 
        <nav-dropdown
          :visible="moreVisible"
          class="n-categories__moreentries"
          :children="moreCategories"
          :target="$refs.morebutton"
          @item-click="onNavDropdownClick"
          /> -->
      </div>
    </div>
  </nav>
</template>

<script>

import { ActionsButton } from '@spices/pepper'

// import NavDropdown from 'components/navigations/dropdown';

export default {
  name: 'CatalogCategoriesNavigation',

  components: {
    ActionsButton
  },

  props: {
    categories: {
      type: Array,
    },
  },

  data(){
    return {
      currentCategoryId: null,
      nVisible: 0,
      moreVisible: false,
      view: {}, // this view
      w: {}, // window
      mobile: 768
    }
  },
  computed: {
    isMobile(){
      return this.w.width <= this.mobile;
    },
    computedCategories(){
      let ret = this.categories.filter(c => c.productsCount > 0);
      ret.forEach((e) => {
        e.label = e.name;
        e.active = e.id == this.currentCategoryId;
      })
      return ret;
    },
    moreCategories(){
      let ret = [];

      // only in desktop
      if (this.isMobile){
        return ret;
      }

      if (this.view && this.view.list && this.moreQty > 0){
        ret = this.computedCategories.slice( -1 * this.moreQty);
      }

      return ret;
    },
    hasMore(){
      return !this.isMobile && this.moreQty > 0;
    },
    moreQty(){
      let ret = 0;
      if (this.view && this.view.entry){
        ret = this.view.entry.length - this.nVisible;
      }
      return ret;
    }
  },

  watch: {
    hasMore(newVal, oldVal){
      this.$nextTick(() => {
        this.updateWindowSize();
      });
    },

    currentCategoryId(value){
     var query = '[data-id="'+ value +'"]';
     var item = document.querySelector(query);
     var container = document.getElementById('n-categories');

     if (item){
       var r = item.getBoundingClientRect();
       var x = r.left + container.scrollLeft + this.w.offsetX || 0;
       TweenLite.to(container, .5, {scrollTo: {x: x, y: 0}})
      }
    }
  },

  methods: {
    goTo(name) {
      var e = document.getElementById(name);
      if (!e){
        return;
      }
      var r = e.getBoundingClientRect();
      var y = r.top + this.w.offsetY + window.scrollY - 16;
      window.scrollTo(0, y);
      // TweenLite.to(window, .7, {scrollTo: {y:y, autoKill:false}});
    },

    getCategoryById(id){
      let ret = null;
      let n = this.categories.length;

      while (n-- > 0){
        let c = this.categories[n];

        if (c.id == id){
          ret = c;
          break;
        }
      }

      return ret;
    },

    updateWindowSize(){
      let rem = 16;
      let col = 14;

      // Get all the element origin position
      let l, t, e, m;
      t = document.getElementsByClassName('n-categories');
      l = document.getElementsByClassName('n-categories__list');
      e = document.getElementsByClassName('n-categories__entry');
      m = document.getElementsByClassName('n-categories__more');

      let r = [t, l, e, m].map((a, i) => {
        let ret = null;

        if (!a.length){
          return ret;
        }

        ret = {};
        if (i != 2){
          ret.view = a[0];
          ret.origin = ret.rect = ret.view.getBoundingClientRect();
        }
        else{
          ret = a.map(c => {
            let ret = {};
            ret.view = c;
            ret.origin = c.getBoundingClientRect();

            return ret;
          });
        }

        return ret;
      });

      this.view = r[0];
      this.view.list = r[1];
      this.view.entry = r[2];
      this.view.more = r[3];

      this.w.width = window.screen.width;
      this.w.offsetX = -1 * ((this.w.width - (col - 1) * (rem / 2)) / col + (rem / 2));
      this.w.offsetY = -1 * (this.view.origin.height);

      // The list position and width
      let lx = this.view.list && this.view.list.origin.left || 0;
      let lw = this.view.list && this.view.list.origin.width || 0;

      // The more button position and width
      let mx = this.view.more && this.view.more.origin.left || 0;
      let mw = this.view.more && this.view.more.origin.width || 0;

      let maxX = (lx + lw) - (mw + (3.375 * rem));
      this.nVisible = 0;

      // console.clear();
      // console.log('maxX', maxX);

      // iterate over every category children to find out the visible ones
      // hide the ones not present at all on the screen
      // hide the ones partially on the screen
      // Array.from(this.view.entry).forEach((el) => {
      // this.view.entry.forEach((el) => {

      Array.prototype.forEach.call(this.view.entry, function(el, index) {
        // let slug = el.view.dataset.slug;
        let r = el.origin;
        let visible = r.left + r.width < maxX;

        if (visible){
          this.nVisible++;
        }

        // console.log(slug, visible, r.left + r.width);
      }.bind(this));
    },

    onScroll(event) {
      let wy = window.scrollY;
      let n = this.computedCategories.length - 1;
      let i = -1;

      let current = null;

      while (i++ < n){
        let prev = current;

        current = this.computedCategories[i];
        let e = document.getElementById(current.id);
        if (!e){
          continue;
        }
        let r = e.getBoundingClientRect();
        current.bottom = r.bottom + this.w.offsetY;
        current.top = r.top + this.w.offsetY;

        // not visible
        if (current.bottom < 0 || prev == null){
          continue;
        }

        if (prev.bottom >= 0 && prev.bottom < current.top){
          this.currentCategoryId = prev.id;
          break;
        }
        else {
          this.currentCategoryId = current.id;
          break;
        }
      }
    },

    onResize(event) {
      this.updateWindowSize();
    },

    onNavDropdownClick({event, child}){
      if (child){
        this.goTo(child.id);
      }
    },

    onGlobalClick(event){
      var parent = this.view.view;
      var child = event.target;

      // Part of the component
      var node = child.parentNode;
      var isChild = false;
      while( node != null ){
        if ( node == parent ){
          isChild = true;
          break;
        }
        node = node.parentNode;
      }

      var isListChild = false;
      var isMoreChild = false;
      if (isChild) {
        // Part of the list
        parent = this.view.list.view;
        child = event.target;
        node = child.parentNode;
        while( node != null ){
          if ( node == parent ){
            isListChild = true;
            break;
          }
          node = node.parentNode;
        }

        // Part of the more
        parent = this.view.more.view;
        child = event.target;
        node = child.parentNode;
        while( node != null ){
          if ( node == parent ){
            isMoreChild = true;
            break;
          }
          node = node.parentNode;
        }
      }

      // console.group(node);
      // console.log('moreVisible', this.moreVisible);
      // console.log('isChild', isChild);
      // console.log('isMoreChild', isMoreChild);
      // console.log('!isListChild', !isListChild);
      // console.log('(isMoreChild && !this.moreVisible)', (isMoreChild && !this.moreVisible));
      // console.log('!(this.moreVisible && isMoreChild)',  !(this.moreVisible && isMoreChild));
      // console.groupEnd();

      if (isChild){
        this.moreVisible = !isListChild || (isMoreChild && !this.moreVisible);
      }else{
        this.moreVisible = false;
      }
    }
  },
  created(){
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
    document.addEventListener('click', this.onGlobalClick);
  },
  mounted() {
    this.current = this.categories[0].id;

    this.$nextTick(() => {
      this.updateWindowSize();
    });
  },

  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('click', this.onGlobalClick);
  }
}
</script>
